export default "__VITE_ASSET__Bmw$KoRj__"